const rightsDate = document.querySelector(
  '.footer__copyright__container__rights__date'
);
if (rightsDate) {
  rightsDate.innerHTML = new Date().getFullYear();
}

import { MDCSelect } from '@material/select';

const topSelectElement = document.querySelector('.topSelect');
const bottomSelectElement = document.querySelector('.bottomSelect');
const colorsSelectElement = document.querySelector(
  '.product-description__selects__colors'
);
const sizesColorsElement = document.querySelector(
  '.product-description__selects__sizes'
);
const listColorsSelectElement = document.querySelector(
  '.single-product__right__selects__colors'
);
const listSizesColorsElement = document.querySelector(
  '.single-product__right__selects__sizes'
);

const listColorsSelectElements = document.querySelectorAll(
  '.single-product__right__selects__colors'
);
const listSizesColorsElements = document.querySelectorAll(
  '.single-product__right__selects__sizes'
);

if (topSelectElement) {
  const topSelect = new MDCSelect(topSelectElement);
}

if (bottomSelectElement) {
  const bottomSelect = new MDCSelect(bottomSelectElement);
}

//if (colorsSelectElement) {
//  const colorsSelect = new MDCSelect(colorsSelectElement);
//}
//
//if (sizesColorsElement) {
//  const sizeSelect = new MDCSelect(sizesColorsElement);
//}
//
//if (listColorsSelectElement) {
//  listColorsSelectElements.forEach(element => {
//    const listColorsSelect = new MDCSelect(element);
//  });
//}
//
//if (listSizesColorsElement) {
//  listSizesColorsElements.forEach(element => {
//    const listSizeSelect = new MDCSelect(element);
//  });
//
//}
//
